import { Button } from "@admin/components/atoms/Button";
import { Personnel } from "@enos-monorepo/lib";

interface ActionProps {
  personnel?: Personnel;
  setDeactivateModal?: React.Dispatch<React.SetStateAction<boolean>>;
  setActivateModal?: React.Dispatch<React.SetStateAction<boolean>>;
  setEditPasswordModal?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpenEditPersonnelModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

export function ActiveActions({
  setDeactivateModal,
  setIsOpenEditPersonnelModal,
  setEditPasswordModal,
}: ActionProps) {
  return (
    <div className="flex justify-center">
      <Button
        variant="clear"
        icon
        size="sm"
        onClick={() => setIsOpenEditPersonnelModal?.(true)}
      >
        <i className="ki-filled ki-notepad-edit"></i>
      </Button>

      <Button
        variant="clear"
        property="info"
        icon
        size="sm"
        onClick={() => setEditPasswordModal?.(true)}
      >
        <i className="ki-filled ki-password-check"></i>
      </Button>

      <Button
        onClick={() => setDeactivateModal?.(true)}
        icon
        property="danger"
        variant="clear"
        size="sm"
      >
        <i className="ki-filled ki-trash-square"></i>
      </Button>
    </div>
  );
}

export function InactiveActions({
  setActivateModal,
  setIsOpenEditPersonnelModal,
  setEditPasswordModal,
}: ActionProps) {
  return (
    <div className="flex justify-center">
      <Button
        variant="clear"
        icon
        size="sm"
        onClick={() => setIsOpenEditPersonnelModal?.(true)}
      >
        <i className="ki-filled ki-notepad-edit"></i>
      </Button>
      <Button
        variant="clear"
        size="sm"
        icon
        property="info"
        onClick={() => setEditPasswordModal?.(true)}
      >
        <i className="ki-filled ki-password-check"></i>
      </Button>

      <Button
        onClick={() => setActivateModal?.(true)}
        icon
        variant="clear"
        property="success"
        size="sm"
      >
        <i className="ki-filled ki-left-square"></i>
      </Button>
    </div>
  );
}
